import script from "./method-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./method-group.vue?vue&type=script&setup=true&lang=ts"

import "./method-group.vue?vue&type=style&index=0&id=5cdfd10c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cdfd10c"]])

export default __exports__